module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("Charlie Palmer is a 50-year-old voluntary worker who fills his days apologising for a big-boned Labrador. He has previously had a short story published, but "), _c('em', [_vm._v("Sitting Down with Evil")]), _vm._v(" is his first novel.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("He lives in Colchester with his wife Emma. His two sons, Louis and Oli, have flown the coop for university studies. In his spare time, Charlie follows Formula 1 and travels to satisfy his Epicurean urges. Needless to say, 2020 remains a constant source of disappointment to him.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0